module.exports = "/static/assets/edd51aa5e9b5e39664fdc0b5b12a3a52.png";